import { Tooltip } from "primereact/tooltip";
import InfoCircleIcon from "@/assets/icons/info-circle.svg?react";
import { actionTooltipProps } from "@/ds";
import styles from "../../etapa-obra.module.scss";
import type { HintProps, HintViewModel } from "./types-hint";

/** ⓘ do rótulo: o balão é ligado ao próprio alvo (hover e foco), não a um seletor global. */
export function HintView({ text, testId, tooltipClassName, alvo }: HintProps & HintViewModel) {
  return (
    <>
      <span
        ref={alvo}
        className={styles.hintTrigger}
        tabIndex={0}
        role="img"
        aria-label={text}
        data-testid={testId}
      >
        <InfoCircleIcon className={styles.hint} aria-hidden />
      </span>
      <Tooltip target={alvo} {...actionTooltipProps(text, { className: tooltipClassName })} />
    </>
  );
}
